import React from "react";
import { useTranslation } from "react-i18next";

const CustomSelect = ({
  value,
  customValue,
  onChange,
  options,
  isWithMontant,
  style,
  titleStrong,
  selectWhat,
  isOffer,
  allowCustomValue = true,
  line, // 👈 contient prix et quantity
}) => {
  const { t } = useTranslation();

  const isOtherSelected = value === "other";
  const actualTva =
    isOtherSelected && customValue !== "" ? Number(customValue) : Number(value);

  const totalTVA =
    ((line?.price || 0) * (line?.quantity || 0) * actualTva) / 100;

  return (
    <div style={{ ...style }}>
      {titleStrong && <strong>{titleStrong}</strong>}

      <select
        value={value}
        onChange={onChange}
        className="table-input border-0"
      >
        <option value="">
          {selectWhat ? selectWhat : t("invoice.select")}
        </option>

        {options?.map((item) => (
          <option
            key={isOffer ? item._id : item.value}
            value={isOffer ? item._id : item.value}
            disabled={item.disabled}
          >
            {isOffer ? item.nom : item.text}
          </option>
        ))}

        {allowCustomValue && (
          <option value="other">{t("invoice.other") || "Autre"}</option>
        )}
      </select>

      {isOtherSelected && (
        <input
          type="number"
          placeholder="TVA personnalisée"
          className="table-input mt-2"
          value={customValue}
          onChange={(e) => {
            const val = parseFloat(e.target.value);
            if (!isNaN(val)) {
              onChange({ target: { value: val } });
            }
          }}
        />
      )}

      {isWithMontant && !isNaN(totalTVA) && (
        <small style={{ marginTop: "4px", color: "#333", fontWeight: "bold" }}>
          {actualTva}% → {totalTVA.toFixed(2)} €
        </small>
      )}
    </div>
  );
};

export default CustomSelect;
